import { useState } from 'react';
import { useFutureOrderStore } from '../../../../../components/Stores/FutureOrdersStore';
import { MonthYearValue, getHighestAbsoluteValue } from '../../../../../utils/MonthYear/MonthYearValue';
import { DateValueInputWithDateSwitch } from '../../../../../components/UI-Elements/Charts/DateValueInputMultiChart/DateValueInputWithDateSwitch';
import { getStartingDate } from '../../FOIndexedClientExposure/FillOrderAdjustmentsUtils';
import React from 'react';
import { getLastDate } from '../../AddNewFutureOrderUtils';

interface Props {
  isEditable?: boolean;
}

export const ExpectedDeliveries: React.FC<Props> = ({ isEditable }) => {
  const { editedFutureOrder, updateOrderDetailsProperty } = useFutureOrderStore();
  const { deliveryDates, quantity, productDeliveryCalendar } = editedFutureOrder.orderDetails;
  const [amountOfMonthsToShow, setAmountOfMonthsToShow] = useState(24);

  const setDeliveryCalendar = (deliveryCalendar: MonthYearValue[]) => {
    if (deliveryDates && quantity) {
      updateOrderDetailsProperty('productDeliveryCalendar', deliveryCalendar);
    }
  };

  return (
    <DateValueInputWithDateSwitch
      mainChart={{
        data: productDeliveryCalendar || [],
        title: 'Product quantity',
        type: 'bar',
        transparent: true,
        isFlipped: true,
        barThickness: 10,
      }}
      updateEditablePropertyFunc={setDeliveryCalendar}
      isHideValueInput={!isEditable}
      numberOfMonthsToShow={amountOfMonthsToShow}
      changeMonths={12}
      startingDate={getStartingDate()}
      endDate={productDeliveryCalendar && getLastDate(productDeliveryCalendar)}
      suggestedMaxValue={productDeliveryCalendar && getHighestAbsoluteValue(productDeliveryCalendar) * 1.5}
      suggestedMinValue={productDeliveryCalendar && -getHighestAbsoluteValue(productDeliveryCalendar) * 1.5}
    />
  );
};
